// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonAuth = {
  username: "ユーザー名",
  password: "パスワード",
  captcha: "認証コード",
  currentPassword: "現在のパスワード",
  newPassword: "新しいパスワード",
  confirmNewPassword: "新しいパスワード（確認）",
  localLogin: "ローカルログイン",
  hybridLogin: "統合認証優先（ローカルログイン併用）",
  ssoLogin: "統合認証ログイン",
} as const;
